<template>
  <section class="advert-channel-workspace">
    <!-- 顶栏操作和过滤框 -->
    <table-toolbar :search.sync="search" :show-refresh="true" :show-export="true" :show-column-settings="true" :columns="columnOptions" :visible-columns.sync="visibleColumns" :default-columns="defaultColumns" :fixed-columns="['# 应用 ID', '# 渠道 ID', '操作']" @refresh="handleReset" @export="handleExport">
      <template slot="left">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddAdnetChannel" class="btn-action">新增渠道</el-button>
      </template>
    </table-toolbar>

    <!-- 主体内容 -->
    <table-page :loading="loading" :empty="tables.length === 0" :show-top-pagination="false" :show-bottom-pagination="false" @retry="fetchData">
      <el-table
        :data="tables"
        stripe
        style="width: 100%"
        class="premium-table"
      >
        <el-table-column key="col-appId" prop="appId" width="115">
          <template slot="header">
            <span class="premium-header-title"><span class="header-icon-hash">#</span> 应用 ID</span>
          </template>
          <template slot-scope="scope">
            <span class="cell-id">{{ scope.row.appId }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-channelId" prop="channelId" width="115">
          <template slot="header">
            <span class="premium-header-title"><span class="header-icon-hash">#</span> 渠道 ID</span>
          </template>
          <template slot-scope="scope">
            <span class="cell-id">{{ scope.row.channelId }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-adnetType" v-if="visibleColumns.includes('adnetType')" prop="adnetType" min-width="120">
          <template slot="header">
            <span class="premium-header-title">广告类型</span>
          </template>
          <template slot-scope="scope">
            <el-tag :type="getAdnetTypeTagType(scope.row.adnetType)" size="small" class="adnet-type-tag">
              {{ adnetTypeFormatter(row = scope.row) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column key="col-argsGroupId" v-if="visibleColumns.includes('argsGroupId')" prop="argsGroupId" min-width="120">
          <template slot="header">
            <span class="premium-header-title">参数组 ID</span>
          </template>
          <template slot-scope="scope">
            <span class="cell-id">{{ scope.row.argsGroupId }}</span>
          </template>
        </el-table-column>

        <el-table-column key="col-poses" v-if="visibleColumns.includes('poses')" prop="poses" min-width="150">
          <template slot="header">
            <span class="premium-header-title">广告位</span>
          </template>
          <template slot-scope="scope">
            <el-tooltip content="点击编辑广告位" placement="top" :open-delay="400">
              <div class="editable-cell" @click="handleChangeAdnetChannel(scope.row)"><span>配置广告位</span><i class="el-icon-edit-outline editable-cell-icon"></i></div>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 占位自适应列，当所有自定义列都被隐藏时，撑开表格宽度以防止布局和“暂无数据”提示错乱 -->
        <el-table-column v-if="visibleColumns.length === 0" min-width="1"></el-table-column>

        <el-table-column key="col-actions" width="80" align="center">
          <template slot="header">
            <span class="premium-header-title">操作</span>
          </template>
          <template slot-scope="scope">
            <el-dropdown @command="handleActionCommand($event, scope.row, scope.$index)" trigger="hover">
              <el-button size="mini" class="action-btn" circle icon="el-icon-more-outline"></el-button>
              <el-dropdown-menu slot="dropdown" class="premium-dropdown-menu">
                <el-dropdown-item command="edit">
                  <i class="el-icon-edit"></i> 编辑渠道
                </el-dropdown-item>
                <el-dropdown-item command="delete" style="color: #ef4444;">
                  <i class="el-icon-delete" style="color: #ef4444;"></i> 删除渠道
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </table-page>

    <!-- dialog -->
    <form-drawer :visible.sync="adnetDialog" :title="type ? '编辑广告渠道' : '新增广告渠道'" :icon="type ? 'el-icon-edit-outline' : 'el-icon-plus'" :loading="saveLoading" width="820px" @save="handleSaveDialog">
      <el-form :model="form" label-position="right" label-width="150px" size="small" :rules="formRules" ref="form" class="drawer-horizontal-form">
        <el-form-item label="应用 ID" prop="appId"><el-input v-model.number="form.appId" :disabled="type" placeholder="请输入应用 ID"></el-input></el-form-item>
        <el-form-item label="渠道 ID" prop="channelId">
              <el-select v-model="form.channelId" collapse-tags style="width: 100%" placeholder="--请选择渠道--" clearable filterable :disabled="type">
                <el-option
                  v-for="item in channelOptions"
                  :key="item.id"
                  :label="item.id + ' -- ' + item.name"
                  :value="item.id"
                  :disabled="channelFilter(item.id)"
                ></el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="广告类型" prop="adnetType">
              <el-select v-model="form.adnetType" collapse-tags style="width: 100%" placeholder="--请选择广告类型--" clearable filterable>
                <el-option v-for="item in adnetType" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="参数组 ID" prop="argsGroupId"><el-input v-model.number="form.argsGroupId" placeholder="请输入参数组 ID"></el-input></el-form-item>

        <!-- 表格化广告位编辑器 -->
        <el-form-item label="广告位配置" style="margin-top: 15px;">
          <div class="poses-table-container">
            <el-table :data="form.poses" stripe class="premium-table inline-edit-table" size="mini" max-height="300">
              <el-table-column label="广告位ID" min-width="100">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.posId" placeholder="广告位ID" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="广告位名称" min-width="120">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.posName" placeholder="广告位名称" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="奖励名称" min-width="100">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.rewardName" placeholder="奖励名称" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="奖励数量" min-width="90">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.rewardAmount" placeholder="奖励数量" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="穿山甲广告位ID" min-width="130">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.pangolinPosId" placeholder="穿山甲ID" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="穿山甲Secret" min-width="130">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.pangolinAppSecret" placeholder="穿山甲Secret" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="优量汇广告位ID" min-width="130">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.tencentPosId" placeholder="优量汇ID" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="优量汇Secret" min-width="130">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.tencentSecret" placeholder="优量汇Secret" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="60" align="center">
                <template slot-scope="scope">
                  <el-button type="danger" size="mini" circle icon="el-icon-delete" plain @click="handleDeleteParams(scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="poses-action-bar" style="margin-top: 10px;">
            <el-button size="mini" icon="el-icon-plus" @click="handleAddParams" class="btn-add-row">添加广告位行</el-button>
          </div>
        </el-form-item>
      </el-form>
    </form-drawer>
  </section>
</template>

<script>
import api from '@/api/channel'
import options from '@/common/options'
import f from '@/filter'
import TableToolbar from '@/components/TableToolbar/index.vue'
import TablePage from '@/components/TablePage/index.vue'
import FormDrawer from '@/components/FormDrawer/index.vue'
import * as XLSX from 'xlsx'

export default {
  name: 'index',
  components: { TableToolbar, TablePage, FormDrawer },
  created () {
    this.fetchData()
    this.fetchChannelList()
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    tables () {
      const search = this.search
      if (search) {
        return this.tableData.filter(data => {
          return Object.keys(data).some(key => {
            return String(data[key]).toLowerCase().indexOf(search.toLowerCase()) > -1
          })
        })
      }
      return this.tableData
    },
    columnOptions () {
      return [
        { prop: 'adnetType', label: '广告类型' },
        { prop: 'argsGroupId', label: '参数组ID' },
        { prop: 'poses', label: '广告位' }
      ]
    },
    defaultColumns () {
      return this.columnOptions.map(item => item.prop)
    }
  },
  watch: {
    appId (val, oldVal) {
      if (val === oldVal) {
        return
      }
      this.fetchData()
      this.fetchChannelList()
    }
  },
  data () {
    return {
      tableData: [],
      search: '',
      form: {
        poses: [{ posId: '', posName: '', rewardName: '', rewardAmount: '', pangolinPosId: '', pangolinAppSecret: '', tencentPosId: '', tencentSecret: '' }]
      },
      channelOptions: [],
      type: false, // true为修改,false为新增
      adnetDialog: false,
      adnetType: options.adnetType,
      visibleColumns: ['adnetType', 'argsGroupId', 'poses'],
      loading: false,
      saveLoading: false,
      formRules: {
        appId: { type: 'number', required: true, message: '请输入id，且不能为空', trigger: 'change' },
        channelId: { type: 'number', required: true, message: '请输入channelId，且不能为空', trigger: 'change' },
        argsGroupId: { type: 'number', required: true, message: '请输入argsGroupId，且不能为空', trigger: 'change' }
      }
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      const params = { appId: this.appId }
      // 获取已配置渠道
      api.getAdnetChannels(params).then(res => {
        this.tableData = res
      }).finally(() => {
        this.loading = false
      })
    },
    // 获取渠道列表
    fetchChannelList () {
      api.getChannelData(this.appId).then(res => {
        this.channelOptions = Object.assign([], res)
      })
    },
    // 新增渠道广告
    handleAddAdnetChannel () {
      api.getAdnetGames(this.appId).then(res => {
        const poses = res.poses ? JSON.parse(res.poses) : [{ posId: '', posName: '', rewardName: '', rewardAmount: '', pangolinPosId: '', pangolinAppSecret: '', tencentPosId: '', tencentSecret: '' }]
        this.form = { poses }
        this.adnetDialog = true
        this.type = false
        this.form.appId = this.appId
      }).catch(() => {
        this.$message.error('请先去 广告应用 配置模板')
      })
    },
    // 修改渠道广告
    handleChangeAdnetChannel (row) {
      const data = Object.assign({}, row)
      data.poses = data.poses.length ? JSON.parse(row.poses) : [{ posId: '', posName: '', rewardName: '', rewardAmount: '', pangolinPosId: '', pangolinAppSecret: '', tencentPosId: '', tencentSecret: '' }]
      this.form = data
      this.adnetDialog = true
      this.type = true
    },
    // 渠道广告 删除
    handleDeleteChannel (id, i) {
      this.$confirm('确定删除吗?', '提示', { type: 'warning' }).then(() => {
        api.deleteAdnetChannels(id).then(() => {
          this.tableData.splice(i, 1)
          this.$message.success('删除成功')
        })
      })
    },
    // 添加参数
    handleAddParams () {
      const params = { posId: '', posName: '', rewardName: '', rewardAmount: '', pangolinPosId: '', pangolinAppSecret: '', tencentPosId: '', tencentSecret: '' }
      if (!this.form.poses) {
        this.$set(this.form, 'poses', [])
      }
      this.form.poses.push(params)
    },
    // 删除参数
    handleDeleteParams (i) {
      this.form.poses.splice(i, 1)
    },
    // 保存
    handleSaveDialog () {
      // 先进行表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.saveLoading = true
          const params = Object.assign({}, this.form)
          if (params.poses) {
            let len = params.poses.length
            const arr = params.poses
            while (len--) {
              if (arr[len].posId === '') {
                arr.splice(len, 1)
              }
            }
          }
          params.poses = params.poses && params.poses.length > 0 ? JSON.stringify(params.poses) : null
          // true 为修改 false 新增
          const f = this.type ? api.putAdnetChannels : api.postAdnetChannels
          f(params).then(() => {
            this.$message.success(this.type ? '修改成功' : '添加成功')
            this.adnetDialog = false
            this.fetchData()
          }).finally(() => {
            this.saveLoading = false
          })
        } else {
          return false
        }
      })
    },
    productsToStr (products) {
      return f.productsToStr(products)
    },
    // 渠道是否可选
    channelFilter (channelId) {
      return this.tableData.some(item => { return item.channelId === channelId })
    },
    adnetTypeFormatter (row) {
      for (const item of options.adnetType) {
        if (item.value === row.adnetType) {
          return item.label
        }
      }
      return row.adnetType
    },
    getAdnetTypeTagType (type) {
      const map = {
        0: 'info', // 无广告: 灰色
        1: 'success', // 自适应: 绿色
        2: 'warning', // 穿山甲: 橙色
        3: 'primary' // 优量汇: 蓝色
      }
      return map[type] || 'info'
    },
    handleReset () {
      this.fetchData()
    },
    handleActionCommand (command, row, index) {
      if (command === 'edit') {
        this.handleChangeAdnetChannel(row)
      } else if (command === 'delete') {
        this.handleDeleteChannel(row.channelId, index)
      }
    },
    handleExport () {
      const worksheet = XLSX.utils.json_to_sheet(this.tables)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '广告渠道')
      XLSX.writeFile(workbook, `广告渠道-${this.$moment().format('YYYYMMDDHHmmss')}.xlsx`)
    }
  }
}
</script>

<style scoped>
.advert-channel-workspace {
  padding: 16px 24px;
}

/* 过滤筛选卡片 */
.filter-card {
  margin-top: 0 !important;
  margin-bottom: 20px;
  padding: 16px 24px;
  border-radius: var(--border-radius-card);
  background: var(--bg-card);
  border: 1px solid #E2E8F0;
  box-shadow: var(--shadow-base);
}

.flex-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.filter-left-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.filter-right-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-action {
  flex-shrink: 0;
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}

.btn-action:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.btn-reset {
  background-color: #F8FAFC !important;
  border-color: #E2E8F0 !important;
  color: #64748B !important;
  height: 32px;
  padding: 0 16px;
  border-radius: 8px !important;
  font-weight: 500 !important;
}

.btn-reset:hover {
  background-color: #F1F5F9 !important;
  color: var(--text-main) !important;
  border-color: #CBD5E1 !important;
}

.btn-setting {
  flex-shrink: 0;
  background-color: #FFFFFF !important;
  border-color: #E2E8F0 !important;
  color: #64748B !important;
  border-radius: 8px !important;
  height: 32px;
  padding: 0 16px;
}

.btn-setting:hover {
  background-color: #F8FAFC !important;
  border-color: #CBD5E1 !important;
  color: var(--text-main) !important;
}

.search-input {
  width: 220px;
  flex-shrink: 0;
}

.search-input :deep(.el-input__inner) {
  border-radius: 8px;
  border-color: #E2E8F0;
  height: 32px;
  line-height: 32px;
  font-weight: 500;
  background-color: #FFFFFF;
  color: var(--text-main);
  transition: all 0.2s ease;
}

.search-input :deep(.el-input__inner:hover) {
  border-color: #CBD5E1;
}

.search-input :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

/* 表格卡片样式 */
.table-card {
  padding: 20px;
  border-radius: var(--border-radius-card);
  background-color: var(--bg-card);
  border: 1px solid #E2E8F0;
  box-shadow: var(--shadow-base);
}

.premium-header-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: inherit;
}

.header-icon-hash {
  font-family: Menlo, Monaco, Consolas, monospace;
  font-size: 13.5px;
  font-weight: 900;
  color: inherit;
}

.cell-id {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace !important;
  font-size: 12.5px !important;
  font-weight: 600;
  color: var(--text-muted);
}

.premium-table {
  border-radius: 8px;
  overflow: hidden;
  border: none !important;
  font-size: 13px !important;
  color: var(--text-main) !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif !important;
}

.premium-table::before {
  display: none !important;
}

.premium-table :deep(.el-table__header-wrapper) th,
.premium-table :deep(.el-table__fixed-header-wrapper) th,
.premium-table :deep(.el-table__fixed-right-header-wrapper) th,
.premium-table :deep(th.el-table__fixed-column) {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.premium-table :deep(.el-table__row) td {
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-light) !important;
}

.premium-table :deep(.el-table__row) {
  transition: background-color 0.2s ease;
}

.premium-table :deep(.el-table__row:hover) td {
  background-color: var(--bg-hover) !important;
}

.premium-table :deep(.el-table__body tr.hover-row > td),
.premium-table :deep(.el-table__body tr.hover-row.current-row > td),
.premium-table :deep(.el-table__body tr.hover-row.el-table__row--striped > td) {
  background-color: var(--bg-hover) !important;
}

.editable-cell { min-height: 30px; display: flex; align-items: center; gap: 8px; padding: 3px 8px; border: 1px solid transparent; border-radius: 8px; color: var(--primary-color); cursor: pointer; transition: all 0.2s ease; }
.editable-cell:hover { border-color: rgba(37, 99, 235, 0.22); background: rgba(37, 99, 235, 0.06); }
.editable-cell-icon { margin-left: auto; opacity: 0; transition: opacity 0.2s ease; }
.editable-cell:hover .editable-cell-icon { opacity: 1; }

.app-id-tag,
.channel-id-tag {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11px;
  color: #475569;
  background: #F1F5F9;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 600;
  display: inline-block;
  letter-spacing: 0.2px;
}

.args-group-id-text {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 600;
  color: #475569;
}

.adnet-type-tag {
  font-weight: 600;
  border-radius: 6px;
}

.poses-config-link {
  font-weight: 600;
  font-size: 13px;
  text-decoration: none !important;
}

.poses-config-link:hover {
  text-decoration: none !important;
}

/* 操作列三点图标 */
.action-btn {
  font-size: 12px;
  border: 1px solid #E2E8F0;
  color: #64748B;
  background: #ffffff;
  transition: all 0.2s ease;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background: #F1F5F9;
  color: var(--text-main);
  border-color: #CBD5E1;
}

/* 列配置 Popover 内部样式 */
.popover-title {
  font-size: 13.5px;
  font-weight: 700;
  color: var(--text-main);
  padding: 6px 4px;
}

.popover-divider {
  height: 1px;
  background: #E2E8F0;
  margin: 6px 0;
}

.popover-body-scroll {
  max-height: 250px;
  overflow-y: auto;
  padding: 4px;
}

.popover-body-scroll::-webkit-scrollbar {
  width: 4px;
}

.popover-body-scroll::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 2px;
}

.popover-body-scroll :deep(.el-checkbox) {
  display: block;
  margin-bottom: 8px;
  margin-right: 0;
}

/* 弹窗及内部表单编辑器 */
.premium-dialog :deep(.el-dialog) {
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
}

.btn-save {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
}

.btn-save:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.poses-table-container {
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  overflow: hidden;
}

.inline-edit-table :deep(.el-input__inner) {
  border-radius: 6px;
  border-color: #E2E8F0;
}

.inline-edit-table :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
}

.btn-add-row {
  background-color: #F8FAFC !important;
  border-color: #E2E8F0 !important;
  color: var(--primary-color) !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
}

.btn-add-row:hover {
  background-color: #F1F5F9 !important;
  border-color: #CBD5E1 !important;
}
</style>
